"use client";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import NoSidebarLayout from "../components/Layout/NoSidebarLayout";
import ProSidebarLayout from "../components/Layout/ProSidebarLayout";
import LcaSidebarLayout from "../components/Layout/LcaSidebarLayout";
import BwvSidebarLayout from "../components/Layout/BwvSidebarLayout";
const RouteWrapper = ({ children }) => {
  const location = useLocation();
  const islogin = useSelector((state) => state.user.isLogin);

  // Define routes that should have no sidebar
  const noSidebarRoutes = [
    "/login",
    "/signup",
    "/majesticHomePage",
    "/settings/reset-password",
    "/all-products",
    "/people-in-mycommunity",
    "/vendordetails",
    "/requestDetails",
    "/people-profile",
    "/items-for-sale",
    "/enlargeImageView ",
    "/dashboardpage/inbox",
    "/userDetails",
    "/bookGurdwara",
  ];

  // Check if current route should have no sidebar
  const shouldHaveNoSidebar = noSidebarRoutes.some((route) => {
    if (route === "/settings/reset-password") {
      return (
        location.pathname.includes("settings/reset-password") ||
        location.hash.includes("settings/reset-password")
      );
    }
    if (route === "/people-profile") {
      return (
        location.pathname.includes("/people-profile") ||
        location.hash.includes("#/people-profile")
      );
    }
        if (route === "/enlargeImageView ") {
      return (
        location.pathname.includes("/enlargeImageView") ||
        location.hash.includes("#/enlargeImageView")
      );
    }
    if (route === "/requestDetails") {
      return (
        location.pathname.includes("/requestDetails") ||
        location.hash.includes("#/requestDetails")
      );
    }
    if (route === "/all-products") {
      return (
        location.pathname === "/all-products" || // Exact match for /all-products
        location.pathname.startsWith("/all-products/") ||
        location.hash === "#/all-products" || // Exact hash match
        location.hash.startsWith("#/all-products/")
      );
    }
    if (route === "/vendordetails") {
      return (
        location.pathname.startsWith("/vendordetails") ||
        location.hash.startsWith("#/vendordetails")
      );
    }
    if (route === "/items-for-sale") {
      return (
        location.pathname.startsWith("/items-for-sale") ||
        location.hash.startsWith("#/items-for-sale")
      );
    }
    if (route === "/dashboardpage/inbox") {
      return (
        location.pathname.startsWith("/dashboardpage/inbox") ||
        location.hash.startsWith("#/dashboardpage/inbox")
      );
    }
    if (route === "/userDetails") {
      return (
        location.pathname.startsWith("/userDetails") ||
        location.hash.startsWith("#/userDetails")
      );
    }
    if (route === "/bookGurdwara") {
      return (
        location.pathname.startsWith("/bookGurdwara") ||
        location.hash.startsWith("#/bookGurdwara")
      );
    }
    return location.pathname === route || location.hash === `#${route}`;
  });

  // Determine which layout to use
  if (shouldHaveNoSidebar) {
    return <NoSidebarLayout islogin={islogin}>{children}</NoSidebarLayout>;
  }

  // Check for Local Community Ads routes - show sidebar even without login
  if (
    location.pathname === "/Localcommunityads" ||
    location.hash === "#/Localcommunityads" ||
    location.pathname === "/enlargeImageView" ||
    location.hash === "#/enlargeImageView" ||
    // location.hash === "#/create-service" ||
    // location.pathname === "/create-service" ||
    location.hash === "#/" ||
    location.pathname === "/" ||
    location.hash === "#/home" ||
    location.pathname === "/home"
  ) {
    return <LcaSidebarLayout islogin={islogin}>{children}</LcaSidebarLayout>;
  }

  // Check for Wedding Vendors routes - handle both pathname and hash
  // Show sidebar regardless of login status
  const isWeddingVendorsRoute =
    location.pathname === "/weddingvendors?selected=vendors-grid" ||
    location.hash === "#/weddingvendors?selected=vendors-grid" ||
    location.pathname.includes("weddingvendors") ||
    location.hash.includes("weddingvendors");

  if (isWeddingVendorsRoute) {
    return <BwvSidebarLayout islogin={islogin}>{children}</BwvSidebarLayout>;
  }

  // Default to ProSidebar for all other routes (only when logged in)
  if (islogin) {
    return <ProSidebarLayout islogin={islogin}>{children}</ProSidebarLayout>;
  } else {
    // Show without sidebar when not logged in for other routes
    return <NoSidebarLayout islogin={islogin}>{children}</NoSidebarLayout>;
  }
};

export default RouteWrapper;
